
/* NETZO HOME BRAND LABELS: branded vendor, NETZO for generic products. */
const nzHomeBrand = input => {
  const vendor = String(input ?? '').trim();
  return !vendor || /^(netzo|oferta online|sin marca|gen[eé]rico|generic)$/i.test(vendor) ? 'NETZO' : vendor;
};
const nzHomeBrandEsc = input => nzHomeBrand(input).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));

document.addEventListener('scroll',()=>{document.documentElement.classList.toggle('nz-scrolled',window.scrollY>24)},{passive:true});

document.addEventListener('DOMContentLoaded',()=>{
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const reveal=[...document.querySelectorAll('.nz-reveal')];
  if(reduced){reveal.forEach(el=>el.classList.add('nz-visible'));}
  else if('IntersectionObserver' in window){
    const io=new IntersectionObserver(entries=>{
      entries.forEach(entry=>{
        if(entry.isIntersecting){entry.target.classList.add('nz-visible');io.unobserve(entry.target);}
      });
    },{threshold:.08,rootMargin:'0px 0px -30px 0px'});
    reveal.forEach(el=>io.observe(el));
  }else{reveal.forEach(el=>el.classList.add('nz-visible'));}

  const bar=document.querySelector('[data-netzo-mobile-buybar]');
  const mainBtn=document.querySelector('.product-form__submit');
  const trigger=document.querySelector('[data-netzo-trigger-add]');
  if(bar&&mainBtn){
    const toggle=()=>{
      const r=mainBtn.getBoundingClientRect();
      bar.classList.toggle('nz-show',r.bottom<0&&window.innerWidth<750);
    };
    toggle();
    window.addEventListener('scroll',toggle,{passive:true});
    window.addEventListener('resize',toggle,{passive:true});
    if(trigger) trigger.addEventListener('click',()=>mainBtn.click());
  }
});

document.addEventListener('DOMContentLoaded',()=>{
  const topBtn=document.querySelector('[data-netzo-to-top]');
  if(topBtn){
    const updateTop=()=>topBtn.classList.toggle('nz-show',window.scrollY>700);
    updateTop();
    window.addEventListener('scroll',updateTop,{passive:true});
    topBtn.addEventListener('click',()=>window.scrollTo({top:0,behavior:'smooth'}));
  }
});

/* NETZO_V8_COMMERCE */
document.addEventListener('DOMContentLoaded',()=>{
  const money = (cents)=>new Intl.NumberFormat('es-CL',{style:'currency',currency:'CLP',maximumFractionDigits:0}).format((Number(cents)||0)/100);

  // Recently viewed
  const recentSections=[...document.querySelectorAll('[data-netzo-recent-section]')];
  let history=[];
  try{history=JSON.parse(localStorage.getItem('netzo_recent_products')||'[]');}catch(e){history=[];}
  const current=recentSections.map(s=>s.dataset.currentHandle).find(Boolean);
  const previous=history.filter(Boolean);
  if(current){
    history=[current,...previous.filter(h=>h!==current)].slice(0,10);
    try{localStorage.setItem('netzo_recent_products',JSON.stringify(history));}catch(e){}
  }
  const renderRecent=async(section)=>{
    const grid=section.querySelector('[data-netzo-recent-grid]');
    if(!grid)return;
    const currentHandle=section.dataset.currentHandle||'';
    const handles=history.filter(h=>h!==currentHandle).slice(0,4);
    if(!handles.length)return;
    const items=(await Promise.all(handles.map(async h=>{
      try{const res=await fetch('/products/'+encodeURIComponent(h)+'.js');return res.ok?await res.json():null;}catch(e){return null;}
    }))).filter(Boolean);
    if(!items.length)return;
    grid.innerHTML=items.map(p=>{
      const compare=Number(p.compare_at_price||0), price=Number(p.price||0);
      const save=compare>price?'<span class="nz-recent-card__save">Ahorras '+money(compare-price)+'</span>':'';
      const img=(p.featured_image||p.images?.[0]||'');
      return '<a class="nz-recent-card" href="/products/'+p.handle+'">'+
        (img?'<img loading="lazy" src="'+img+'" alt="'+String(p.title||'').replace(/"/g,'&quot;')+'">':'')+
        '<div class="nz-recent-card__body"><span class="nz-recent-card__vendor">'+nzHomeBrandEsc(p.vendor)+'</span><h3>'+p.title+'</h3><span class="nz-recent-card__price">'+money(price)+'</span>'+save+'</div></a>';
    }).join('');
    section.hidden=false;
    requestAnimationFrame(()=>section.classList.add('nz-visible'));
  };
  recentSections.forEach(renderRecent);

  // Compare up to 3 products
  const storageKey='netzo_compare_products';
  let compare=[];
  try{compare=JSON.parse(localStorage.getItem(storageKey)||'[]');}catch(e){compare=[];}
  const dock=document.querySelector('[data-netzo-compare-dock]');
  const modal=document.querySelector('[data-netzo-compare-modal]');
  const table=document.querySelector('[data-netzo-compare-table]');
  const count=document.querySelector('[data-netzo-compare-count]');
  const saveCompare=()=>{try{localStorage.setItem(storageKey,JSON.stringify(compare));}catch(e){} updateCompareUI();};
  const updateCompareUI=()=>{
    document.querySelectorAll('[data-netzo-compare]').forEach(btn=>{
      const active=compare.includes(btn.dataset.handle);
      btn.classList.toggle('nz-active',active);
      if(active && btn.classList.contains('nz-card-compare')) btn.textContent='✓ En comparador';
      else if(btn.classList.contains('nz-card-compare')) btn.textContent='⚖️ Comparar';
      else if(active) btn.textContent='✓ Producto añadido al comparador';
      else btn.textContent='⚖️ Comparar este producto';
    });
    if(count)count.textContent=compare.length+' '+(compare.length===1?'producto seleccionado':'productos seleccionados');
    if(dock)dock.classList.toggle('nz-show',compare.length>0);
  };
  document.addEventListener('click',async e=>{
    const btn=e.target.closest('[data-netzo-compare]');
    if(btn){
      e.preventDefault();e.stopPropagation();
      const h=btn.dataset.handle;if(!h)return;
      if(compare.includes(h)) compare=compare.filter(x=>x!==h);
      else if(compare.length<3) compare.push(h);
      else {alert('Puedes comparar hasta 3 productos a la vez.');return;}
      saveCompare();return;
    }
    if(e.target.closest('[data-netzo-compare-clear]')){compare=[];saveCompare();return;}
    if(e.target.closest('[data-netzo-compare-close]')){modal?.classList.remove('nz-open');modal?.setAttribute('aria-hidden','true');return;}
    if(e.target.closest('[data-netzo-compare-open]')){
      if(!compare.length)return;
      if(table)table.innerHTML='<div style="padding:20px">Cargando comparación…</div>';
      modal?.classList.add('nz-open');modal?.setAttribute('aria-hidden','false');
      const items=(await Promise.all(compare.map(async h=>{
        try{const res=await fetch('/products/'+encodeURIComponent(h)+'.js');return res.ok?await res.json():null;}catch(err){return null;}
      }))).filter(Boolean);
      if(table)table.innerHTML=items.map(p=>{
        const price=Number(p.price||0), cp=Number(p.compare_at_price||0);
        const safe=x=>String(x??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
        const sale=cp>price?'<div class="nz-compare-card__sale">Ahorras '+money(cp-price)+'</div>':'';
        const img=p.featured_image||p.images?.[0]||'';
        const type=String(p.type||p.product_type||'').trim();
        const variants=Array.isArray(p.variants)?p.variants:[];
        const sku=variants.length===1?String(variants[0].sku||'').trim():'';
        const options=Array.isArray(p.options)?p.options.map(o=>typeof o==='string'?o:o?.name).filter(o=>o&&o!=='Title'):[];
        const facts='<dl class="nz44-compare-facts">'+
          (type?'<div><dt>Tipo</dt><dd>'+safe(type)+'</dd></div>':'')+
          (sku?'<div><dt>Referencia</dt><dd>'+safe(sku)+'</dd></div>':'')+
          (options.length?'<div><dt>Opciones</dt><dd>'+safe(options.join(', '))+'</dd></div>':'')+
          '</dl>';
        return '<article class="nz-compare-card"><button class="nz-compare-remove" data-netzo-remove-compare="'+safe(p.handle)+'" type="button" aria-label="Quitar">×</button>'+
          (img?'<img loading="lazy" src="'+safe(img)+'" alt="'+safe(p.title)+'">':'')+
          '<div class="nz-compare-card__vendor">'+safe(p.vendor||'')+'</div><h3>'+safe(p.title)+'</h3>'+
          '<div class="nz-compare-card__price">'+money(price)+'</div>'+sale+
          '<div class="nz-compare-card__stock">'+(p.available?'● Disponible':'● Agotado')+'</div>'+facts+
          '<a class="nz-btn nz-btn--secondary" href="/products/'+encodeURIComponent(p.handle)+'" style="margin-top:12px">Ver ficha completa</a></article>';
      }).join('');
      return;
    }
    const rm=e.target.closest('[data-netzo-remove-compare]');
    if(rm){compare=compare.filter(h=>h!==rm.dataset.netzoRemoveCompare);saveCompare();rm.closest('.nz-compare-card')?.remove();if(!compare.length)modal?.classList.remove('nz-open');}
  });
  updateCompareUI();
});

/* NETZO_V9_APP */
document.addEventListener('DOMContentLoaded',()=>{
  const money=(cents)=>new Intl.NumberFormat('es-CL',{style:'currency',currency:'CLP',maximumFractionDigits:0}).format((Number(cents)||0)/100);
  const esc=(s)=>String(s??'').replace(/[&<>"']/g,m=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[m]));

  // Smart search
  const searchInput=document.querySelector('[data-netzo-search-input]');
  const searchPanel=document.querySelector('[data-netzo-search-panel]');
  const searchResults=document.querySelector('[data-netzo-search-results]');
  const searchAll=document.querySelector('[data-netzo-search-all]');
  const recentWrap=document.querySelector('[data-netzo-recent-searches]');
  const recentList=document.querySelector('[data-netzo-recent-search-list]');
  let searchTimer;
  const recentKey='netzo_recent_searches';
  const getRecent=()=>{try{return JSON.parse(localStorage.getItem(recentKey)||'[]').slice(0,5)}catch(e){return[]}};
  const saveRecent=(q)=>{if(!q)return;const arr=[q,...getRecent().filter(x=>x.toLowerCase()!==q.toLowerCase())].slice(0,5);try{localStorage.setItem(recentKey,JSON.stringify(arr))}catch(e){}};
  const renderRecentSearches=()=>{
    if(!recentWrap||!recentList)return;
    const arr=getRecent();recentWrap.hidden=!arr.length;
    recentList.innerHTML=arr.map(q=>'<button type="button" data-netzo-recent-q="'+esc(q)+'">'+esc(q)+'</button>').join('');
  };
  const showSearch=()=>{if(searchPanel)searchPanel.hidden=false;renderRecentSearches()};
  const hideSearch=()=>{if(searchPanel)searchPanel.hidden=true};
  const renderSearch=async(q)=>{
    if(!searchResults||!q.trim()){if(searchResults)searchResults.innerHTML='';renderRecentSearches();return;}
    const normalize=(raw)=>{
      const s=String(raw||'').trim();
      const low=s.toLowerCase();
      const aliases=[
        [/zapatilla eléctrica|zapatilla electrica|extensión eléctrica|extension electrica/,'alargador eléctrico'],
        [/power bank|powerbank/,'batería externa'],
        [/plancha de pelo|plancha pelo/,'alisador pelo'],
        [/soporte television|soporte televisión|soporte tele/,'soporte tv'],
        [/botella térmica|botella termica/,'termo']
      ];
      for(const [rx,val] of aliases){if(rx.test(low))return val}
      return s;
    };
    const fetchSuggest=async(term)=>{
      const url='/search/suggest.json?q='+encodeURIComponent(term)+'&resources[type]=product,collection,page,article&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last';
      const res=await fetch(url,{headers:{Accept:'application/json'}});
      return res.json();
    };
    try{
      let data=await fetchSuggest(q);
      let results=data?.resources?.results||{};
      let products=results.products||[];
      const normalized=normalize(q);
      if(!products.length&&normalized.toLowerCase()!==q.trim().toLowerCase()){
        data=await fetchSuggest(normalized);
        results=data?.resources?.results||{};
        products=results.products||[];
      }
      const collections=results.collections||[];
      const pages=results.pages||[];
      const articles=results.articles||[];
      let html='';
      if(products.length){
        html+='<div class="nz-search-group"><span class="nz-search-group__title">Productos</span>'+
        products.map(p=>{
          const img=p.featured_image?.url||p.featured_image||p.image||'';
          const price=typeof p.price==='number'?money(p.price):p.price||'';
          return '<a class="nz-search-result" href="'+p.url+'">'+(img?'<img src="'+img+'" alt="">':'')+'<span><strong>'+esc(p.title)+'</strong><small>'+esc(p.vendor||'')+(price?' · '+esc(price):'')+'</small></span></a>';
        }).join('')+'</div>';
      }
      const content=[...collections,...pages,...articles].slice(0,6);
      if(content.length){
        html+='<div class="nz-search-group"><span class="nz-search-group__title">Categorías y guías</span>'+
          content.map(x=>'<a class="nz-search-simple" href="'+x.url+'">'+esc(x.title||x.name||'Ver resultado')+'</a>').join('')+'</div>';
      }
      searchResults.innerHTML=html||'<div class="nz-search-empty">No encontramos sugerencias. Prueba con otra palabra.</div>';
      if(searchAll)searchAll.href='/search?q='+encodeURIComponent(q)+'&type=product';
    }catch(e){searchResults.innerHTML='<div class="nz-search-empty">Escribe y presiona Buscar para ver todos los resultados.</div>'}
  };
  if(searchInput){
    searchInput.addEventListener('focus',showSearch);
    searchInput.addEventListener('input',()=>{showSearch();clearTimeout(searchTimer);searchTimer=setTimeout(()=>renderSearch(searchInput.value),180)});
    searchInput.closest('form')?.addEventListener('submit',()=>saveRecent(searchInput.value.trim()));
    document.addEventListener('click',e=>{if(!e.target.closest('.nz-smart-search')&&!e.target.closest('[data-netzo-recent-q]'))hideSearch()});
    document.addEventListener('click',e=>{const b=e.target.closest('[data-netzo-recent-q]');if(b){searchInput.value=b.dataset.netzoRecentQ||'';showSearch();renderSearch(searchInput.value);searchInput.focus()}});
  }

  // Wishlist
  const wishKey='netzo_wishlist_products';
  let wishes=[];try{wishes=JSON.parse(localStorage.getItem(wishKey)||'[]')}catch(e){wishes=[]}
  wishes=[...new Set(wishes.filter(Boolean))].slice(0,50);
  const wishDrawer=document.querySelector('[data-netzo-wishlist-drawer]');
  const wishContent=document.querySelector('[data-netzo-wishlist-content]');
  const wishEmpty=document.querySelector('[data-netzo-wishlist-empty]');
  const persistWish=()=>{try{localStorage.setItem(wishKey,JSON.stringify(wishes))}catch(e){};updateWishUI()};
  const updateWishUI=()=>{
    document.querySelectorAll('[data-netzo-wishlist-count]').forEach(el=>{el.textContent=wishes.length;el.hidden=!wishes.length});
    document.querySelectorAll('[data-netzo-wishlist]').forEach(btn=>{
      const active=wishes.includes(btn.dataset.handle);btn.classList.toggle('nz-active',active);
      if(btn.classList.contains('nz-card-wish'))btn.setAttribute('aria-label',active?'Quitar de favoritos':'Guardar en favoritos');
      else btn.textContent=active?'♥ Guardado en favoritos':'♡ Guardar en favoritos';
    });
  };
  const renderWishlist=async()=>{
    if(!wishContent||!wishEmpty)return;
    if(!wishes.length){wishContent.innerHTML='';wishEmpty.hidden=false;return}
    wishEmpty.hidden=true;wishContent.innerHTML='<div style="padding:20px;text-align:center">Cargando favoritos…</div>';
    const items=(await Promise.all(wishes.map(async h=>{try{const r=await fetch('/products/'+encodeURIComponent(h)+'.js');return r.ok?await r.json():null}catch(e){return null}}))).filter(Boolean);
    wishContent.innerHTML=items.map(p=>{
      const img=p.featured_image||p.images?.[0]||'';
      return '<article class="nz-wish-item">'+(img?'<a href="/products/'+p.handle+'"><img src="'+img+'" alt="'+esc(p.title)+'"></a>':'')+'<div><a href="/products/'+p.handle+'"><strong>'+esc(p.title)+'</strong></a><small>'+esc(p.vendor||'')+'</small><div class="nz-wish-item__price">'+money(p.price)+'</div></div><button class="nz-wish-remove" type="button" data-netzo-wish-remove="'+p.handle+'" aria-label="Quitar">×</button></article>';
    }).join('');
  };
  document.addEventListener('click',e=>{
    const wish=e.target.closest('[data-netzo-wishlist]');
    if(wish){e.preventDefault();e.stopPropagation();const h=wish.dataset.handle;if(!h)return;wishes=wishes.includes(h)?wishes.filter(x=>x!==h):[h,...wishes].slice(0,50);persistWish();return}
    if(e.target.closest('[data-netzo-wishlist-open]')){wishDrawer?.classList.add('nz-open');wishDrawer?.setAttribute('aria-hidden','false');renderWishlist();return}
    if(e.target.closest('[data-netzo-wishlist-close]')){wishDrawer?.classList.remove('nz-open');wishDrawer?.setAttribute('aria-hidden','true');return}
    const rm=e.target.closest('[data-netzo-wish-remove]');if(rm){wishes=wishes.filter(x=>x!==rm.dataset.netzoWishRemove);persistWish();renderWishlist()}
  });
  updateWishUI();

  // Share
  document.addEventListener('click',async e=>{
    const b=e.target.closest('[data-netzo-share]');if(!b)return;
    const data={title:b.dataset.title||document.title,url:b.dataset.url||location.href};
    try{
      if(navigator.share)await navigator.share(data);
      else{await navigator.clipboard.writeText(data.url);const old=b.textContent;b.textContent='✓ Enlace copiado';setTimeout(()=>b.textContent=old,1600)}
    }catch(err){}
  });

  // Quick view
  const qv=document.querySelector('[data-netzo-quickview]'), qvBody=document.querySelector('[data-netzo-quickview-body]');
  const openQuick=async(handle)=>{
    if(!qv||!qvBody)return;
    qv.classList.add('nz-open');qv.setAttribute('aria-hidden','false');qvBody.innerHTML='<div class="nz-quickview__loading">Cargando producto…</div>';
    try{
      const res=await fetch('/products/'+encodeURIComponent(handle)+'.js');const p=await res.json();
      const img=p.featured_image||p.images?.[0]||'';
      const cp=Number(p.compare_at_price||0), price=Number(p.price||0);
      const save=cp>price?'<div class="nz-quickview__save">Ahorras '+money(cp-price)+'</div>':'';
      const canQuickAdd=p.variants?.length===1&&p.variants[0]?.available;
      const mainAction=canQuickAdd?'<button type="button" class="nz-btn nz-btn--primary nz-quickview-add" data-netzo-qv-add="'+p.variants[0].id+'">Agregar al carrito</button>':'<a class="nz-btn nz-btn--primary" href="/products/'+p.handle+'">Elegir opciones</a>';
      qvBody.innerHTML='<div class="nz-quickview__grid"><div class="nz-quickview__image">'+(img?'<img src="'+img+'" alt="'+esc(p.title)+'">':'')+'</div><div><span class="nz-quickview__vendor">'+esc(p.vendor||'')+'</span><h2>'+esc(p.title)+'</h2><div class="nz-quickview__price"><strong>'+money(price)+'</strong>'+(cp>price?'<s>'+money(cp)+'</s>':'')+'</div>'+save+'<div class="nz-quickview__availability">'+(p.available?'● Disponible':'● Agotado')+'</div><div class="nz-quickview__actions">'+mainAction+'<a class="nz-btn nz-btn--secondary" href="/products/'+p.handle+'">Ver ficha completa</a></div></div></div>';
    }catch(e){qvBody.innerHTML='<div class="nz-search-empty">No fue posible cargar la vista rápida.</div>'}
  };
  document.addEventListener('click',async e=>{
    const b=e.target.closest('[data-netzo-quickview]');if(b){e.preventDefault();e.stopPropagation();openQuick(b.dataset.handle);return}
    if(e.target.closest('[data-netzo-quickview-close]')){qv?.classList.remove('nz-open');qv?.setAttribute('aria-hidden','true');return}
    const add=e.target.closest('[data-netzo-qv-add]');
    if(add){
      add.disabled=true;const original=add.textContent;add.textContent='Agregando…';
      try{
        const cart=document.querySelector('cart-drawer');
        const fd=new FormData();fd.append('id',add.dataset.netzoQvAdd);fd.append('quantity','1');
        if(cart?.getSectionsToRender){fd.append('sections',cart.getSectionsToRender().map(s=>s.id));fd.append('sections_url',window.location.pathname)}
        const res=await fetch(window.routes?.cart_add_url||'/cart/add.js',{method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:fd});
        const data=await res.json();if(!res.ok||data.status)throw new Error(data.description||'Error');
        qv?.classList.remove('nz-open');qv?.setAttribute('aria-hidden','true');
        if(cart?.renderContents)cart.renderContents(data);else location.href='/cart';
      }catch(err){add.textContent='No se pudo agregar';setTimeout(()=>{add.textContent=original;add.disabled=false},1800)}
    }
  });
});

/* NETZO_V10_FULL_PREMIUM */
document.addEventListener('DOMContentLoaded',()=>{
  const progress=document.querySelector('[data-netzo-scroll-progress]');
  const updateProgress=()=>{
    if(!progress)return;
    const max=Math.max(1,document.documentElement.scrollHeight-window.innerHeight);
    progress.style.width=Math.min(100,Math.max(0,(window.scrollY/max)*100))+'%';
  };
  updateProgress();
  window.addEventListener('scroll',updateProgress,{passive:true});
  window.addEventListener('resize',updateProgress,{passive:true});

  window.netzoToast=(icon,title,detail='')=>{
    const stack=document.querySelector('[data-netzo-toast-stack]'); if(!stack)return;
    const el=document.createElement('div');el.className='nz-toast';
    el.innerHTML='<span class="nz-toast__icon">'+icon+'</span><span><strong>'+title+'</strong>'+(detail?'<small>'+detail+'</small>':'')+'</span>';
    stack.appendChild(el);
    setTimeout(()=>{el.style.opacity='0';el.style.transform='translateY(-8px)';setTimeout(()=>el.remove(),220)},2600);
  };

  document.addEventListener('click',e=>{
    const wish=e.target.closest('[data-netzo-wishlist]');
    if(wish) setTimeout(()=>window.netzoToast?.('♡','Favoritos actualizados','Puedes revisar tus guardados cuando quieras.'),50);
    const comp=e.target.closest('[data-netzo-compare]');
    if(comp) setTimeout(()=>window.netzoToast?.('⚖️','Comparador actualizado','Puedes comparar hasta 3 productos.'),50);
    const share=e.target.closest('[data-netzo-share]');
    if(share) setTimeout(()=>window.netzoToast?.('↗','Compartir producto','Abriendo opciones para compartir.'),50);
  });
});

/* NETZO_V11_PREMIUM_FEATURES */
document.addEventListener('DOMContentLoaded',()=>{
  const money=(cents)=>new Intl.NumberFormat('es-CL',{style:'currency',currency:'CLP',maximumFractionDigits:0}).format((Number(cents)||0)/100);
  const esc=(s)=>String(s??'').replace(/[&<>"']/g,m=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[m]));

  // Sticky product navigation
  document.addEventListener('click',e=>{
    const b=e.target.closest('[data-netzo-scroll-target]'); if(!b)return;
    const target=document.querySelector(b.dataset.netzoScrollTarget); if(!target)return;
    target.scrollIntoView({behavior:'smooth',block:'start'});
  });

  // Desktop sticky buy bar
  const desktopBar=document.querySelector('[data-netzo-desktop-buybar]');
  const mainAdd=document.querySelector('.product-form__submit');
  const desktopTrigger=document.querySelector('[data-netzo-desktop-add]');
  if(desktopBar&&mainAdd){
    const update=()=>{
      const r=mainAdd.getBoundingClientRect();
      desktopBar.classList.toggle('nz-show',window.innerWidth>=990&&r.bottom<0);
    };
    update();window.addEventListener('scroll',update,{passive:true});window.addEventListener('resize',update,{passive:true});
    desktopTrigger?.addEventListener('click',()=>mainAdd.click());
  }

  // Related complements using Shopify Recommendations API
  const section=document.querySelector('[data-netzo-complements]');
  if(section){
    const grid=section.querySelector('[data-netzo-complement-grid]');
    const bar=section.querySelector('[data-netzo-complement-bar]');
    const count=section.querySelector('[data-netzo-complement-count]');
    const addBtn=section.querySelector('[data-netzo-complement-add]');
    const productId=section.dataset.productId;
    const updateCount=()=>{
      const checked=[...section.querySelectorAll('[data-netzo-complement-check]:checked')];
      const n=checked.length;
      const total=checked.reduce((sum,i)=>sum+Number(i.dataset.price||0),0);
      if(count)count.textContent=n+' '+(n===1?'seleccionado':'seleccionados')+(n?' · '+money(total):'');
      if(bar)bar.hidden=n===0;
    };
    fetch('/recommendations/products.json?product_id='+encodeURIComponent(productId)+'&limit=6&intent=related',{headers:{Accept:'application/json'}})
      .then(r=>r.json()).then(data=>{
        const type=String(section.dataset.productType||'').toLowerCase().trim();
        const vendor=String(section.dataset.productVendor||'').toLowerCase().trim();
        const rank=p=>{
          const candidateType=String(p.type||p.product_type||'').toLowerCase().trim();
          const candidateVendor=String(p.vendor||'').toLowerCase().trim();
          return (type&&candidateType===type?4:0)+(vendor&&vendor!=='netzo'&&candidateVendor===vendor?1:0);
        };
        const products=(data.products||[])
          .filter(p=>p.available&&p.handle&&p.featured_image&&String(p.id)!==String(productId))
          .sort((a,b)=>rank(b)-rank(a)).slice(0,3);
        if(!products.length){section.hidden=true;return}
        grid.innerHTML=products.map(p=>{
          const variant=(p.variants||[]).find(v=>v.available)||p.variants?.[0];
          if(!variant)return '';
          const price=Number(variant.price||p.price||0), compare=Number(variant.compare_at_price||p.compare_at_price||0);
          const save=compare>price?'<span class="nz-complement-card__save">Ahorras '+money(compare-price)+'</span>':'';
          const img=p.featured_image||p.images?.[0]||'';
          return '<article class="nz-complement-card">'+
            '<label class="nz-complement-check"><input type="checkbox" data-netzo-complement-check data-price="'+price+'" value="'+variant.id+'" aria-label="Seleccionar '+esc(p.title)+'"></label>'+
            (img?'<a href="/products/'+p.handle+'"><img src="'+img+'" alt="'+esc(p.title)+'"></a>':'')+
            '<div class="nz-complement-card__copy"><small>'+esc(p.vendor||'')+'</small><h3><a href="/products/'+p.handle+'">'+esc(p.title)+'</a></h3><div class="nz-complement-card__price">'+money(price)+'</div>'+save+'</div></article>';
        }).join('');
        section.querySelectorAll('[data-netzo-complement-check]').forEach(i=>i.addEventListener('change',updateCount));
      }).catch(()=>{section.hidden=true});

    addBtn?.addEventListener('click',async()=>{
      const ids=[...section.querySelectorAll('[data-netzo-complement-check]:checked')].map(i=>Number(i.value)).filter(Boolean);
      if(!ids.length)return;
      addBtn.disabled=true;const old=addBtn.textContent;addBtn.textContent='Agregando…';
      try{
        const cart=document.querySelector('cart-drawer');
        const body={items:ids.map(id=>({id,quantity:1}))};
        if(cart?.getSectionsToRender){
          body.sections=cart.getSectionsToRender().map(s=>s.id);
          body.sections_url=window.location.pathname;
        }
        const res=await fetch(window.routes?.cart_add_url||'/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});
        const data=await res.json();if(!res.ok||data.status)throw new Error(data.description||'Error');
        window.netzoToast?.('✓','Productos agregados','Ya están en tu carrito.');
        section.querySelectorAll('[data-netzo-complement-check]').forEach(i=>i.checked=false);updateCount();
        if(cart?.renderContents)cart.renderContents(data);
      }catch(err){
        window.netzoToast?.('!','No pudimos agregar','Puedes abrir cada producto y agregarlo por separado.');
      }finally{addBtn.disabled=false;addBtn.textContent=old}
    });
  }
});

/* NETZO_V12_V13_GRAND_UPDATE */
document.addEventListener('DOMContentLoaded',()=>{
  // Newsletter: once every 14 days. Avoid interruptions inside Shopify editor.
  const popup=document.querySelector('[data-netzo-newsletter]');
  const popupKey='netzo_newsletter_seen_v13';
  if(popup && !window.Shopify?.designMode){
    let last=0;try{last=Number(localStorage.getItem(popupKey)||0)}catch(e){}
    const eligible=!last || Date.now()-last>14*24*60*60*1000;
    let opened=false;
    const openPopup=()=>{
      if(!eligible||opened)return;
      opened=true;popup.classList.add('nz-open');popup.setAttribute('aria-hidden','false');
      try{localStorage.setItem(popupKey,String(Date.now()))}catch(e){}
    };
    const delay=window.innerWidth<750?35000:26000;
    const timer=setTimeout(openPopup,delay);
    if(window.innerWidth>=990){
      document.addEventListener('mouseout',e=>{
        if(e.clientY<=0 && !e.relatedTarget){clearTimeout(timer);openPopup();}
      },{once:true});
    }
    document.addEventListener('click',e=>{
      if(e.target.closest('[data-netzo-newsletter-close]')){
        clearTimeout(timer);popup.classList.remove('nz-open');popup.setAttribute('aria-hidden','true');
      }
    });
  }

  // Intent-based prefetch: faster perceived product navigation, limited to 5 links.
  if('HTMLLinkElement' in window && window.matchMedia('(pointer:fine)').matches){
    const prefetched=new Set();
    document.addEventListener('pointerover',e=>{
      const a=e.target.closest('a[href*="/products/"]');
      if(!a||prefetched.size>=5)return;
      const href=a.href;if(!href||prefetched.has(href))return;
      prefetched.add(href);
      const l=document.createElement('link');l.rel='prefetch';l.href=href;document.head.appendChild(l);
    },{passive:true});
  }

  // Header glass state even when the browser restores a scrolled position.
  const syncHeader=()=>document.documentElement.classList.toggle('nz-scrolled',window.scrollY>18);
  syncHeader();window.addEventListener('scroll',syncHeader,{passive:true});
});

/* NETZO_V13_PERSONALIZATION */
document.addEventListener('DOMContentLoaded',()=>{
  const section=document.querySelector('[data-netzo-for-you]');
  if(section){
    let history=[];try{history=JSON.parse(localStorage.getItem('netzo_recent_products')||'[]')}catch(e){}
    const last=history?.[0];
    if(last){
      fetch('/products/'+encodeURIComponent(last)+'.js',{headers:{Accept:'application/json'}})
        .then(r=>r.ok?r.json():Promise.reject())
        .then(base=>{
          return fetch('/recommendations/products.json?product_id='+encodeURIComponent(base.id)+'&limit=8&intent=related',{headers:{Accept:'application/json'}})
            .then(r=>r.json()).then(data=>({base,products:data.products||[]}));
        })
        .then(({base,products})=>{
          const items=products.filter(p=>p.available&&p.handle!==base.handle).slice(0,4);if(!items.length)return;
          const grid=section.querySelector('[data-netzo-for-you-grid]');
          const title=section.querySelector('[data-netzo-for-you-title]');
          const copy=section.querySelector('[data-netzo-for-you-copy]');
          if(title)title.textContent='También te puede interesar';
          if(copy)copy.textContent='Productos relacionados con lo que viste recientemente.';
          const money=c=>new Intl.NumberFormat('es-CL',{style:'currency',currency:'CLP',maximumFractionDigits:0}).format((Number(c)||0)/100);
          const esc=s=>String(s??'').replace(/[&<>"']/g,m=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[m]));
          grid.innerHTML=items.map(p=>{
            const price=Number(p.price||0),cp=Number(p.compare_at_price||0),img=p.featured_image||p.images?.[0]||'';
            const save=cp>price?'<span class="nz-for-you-card__save">Ahorras '+money(cp-price)+'</span>':'';
            return '<article class="nz-for-you-card"><div class="nz-for-you-card__media"><button class="nz-card-wish" type="button" data-netzo-wishlist data-handle="'+p.handle+'" aria-label="Guardar '+esc(p.title)+'">♡</button><a href="/products/'+p.handle+'">'+(img?'<img loading="lazy" src="'+img+'" alt="'+esc(p.title)+'">':'')+'</a></div><div class="nz-for-you-card__body"><small>'+esc(nzHomeBrand(p.vendor))+'</small><h3><a href="/products/'+p.handle+'">'+esc(p.title)+'</a></h3><div class="nz-for-you-card__price">'+money(price)+'</div>'+save+'<div class="nz-for-you-card__actions"><button type="button" data-netzo-quickview data-handle="'+p.handle+'">Vista rápida</button><a href="/products/'+p.handle+'">Ver producto</a></div></div></article>';
          }).join('');
          section.hidden=false;requestAnimationFrame(()=>section.classList.add('nz-visible'));
        }).catch(()=>{});
    }
  }

  // If newsletter form returned success, force-open once so the customer sees confirmation.
  const success=document.querySelector('.nz-newsletter-v13__success');
  const popup=document.querySelector('[data-netzo-newsletter]');
  if(success&&popup){popup.classList.add('nz-open');popup.setAttribute('aria-hidden','false')}
});

/* NETZO_V14_V15_POLISH */
document.addEventListener('DOMContentLoaded',()=>{
  const pulsePrice=()=>{
    document.querySelectorAll('.product__info-container .price').forEach(el=>{
      el.classList.remove('nz-price-pulse');
      void el.offsetWidth;
      el.classList.add('nz-price-pulse');
      setTimeout(()=>el.classList.remove('nz-price-pulse'),500);
    });
  };
  document.addEventListener('variant:change',pulsePrice);
  document.addEventListener('change',e=>{
    if(e.target.closest('variant-selects,variant-radios'))setTimeout(pulsePrice,80);
  });
});


/* NETZO_FINAL_CATEGORIES_BUTTON */
document.addEventListener('click',e=>{
  const trigger=e.target.closest('[data-netzo-categories-open]');
  if(!trigger)return;
  e.preventDefault();

  const root=document.getElementById('Details-menu-drawer-container');
  if(!root)return;
  const rootSummary=root.querySelector(':scope > summary');

  if(!root.open && rootSummary)rootSummary.click();

  window.setTimeout(()=>{
    let catSummary=document.getElementById('HeaderDrawer-categorias');
    if(!catSummary){
      catSummary=[...document.querySelectorAll('#menu-drawer summary')].find(el=>
        (el.textContent||'').trim().toLowerCase().startsWith('categor')
      );
    }
    if(catSummary){
      const details=catSummary.closest('details');
      if(details && !details.open)catSummary.click();
    }
  },120);
});


/* NETZO_PRODUCT_DRAWER_OVERLAY_FIX_FINAL */
document.addEventListener('DOMContentLoaded',()=>{
  const drawer=document.getElementById('Details-menu-drawer-container');
  if(!drawer)return;

  const syncMenuState=()=>{
    document.body.classList.toggle('nz-menu-open',drawer.hasAttribute('open'));
  };

  drawer.addEventListener('toggle',syncMenuState);
  syncMenuState();
});
